import { combineReducers } from 'redux';
import jobInvocations from './jobInvocations/';

export default combineReducers({
  jobInvocations,
});



// WEBPACK FOOTER //
// ./vendor/ruby/2.5.0/gems/foreman_remote_execution-4.5.6/webpack/react_app/redux/reducers/index.js